import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/wallet-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-d813356a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "download" }
const _hoisted_2 = { class: "open-wallet-main" }
const _hoisted_3 = { class: "open-wallet-info" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wallet-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_5 = {
  key: 0,
  class: "receive-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_redpack_info = _resolveComponent("redpack-info")!
  const _component_personality_button = _resolveComponent("personality-button")!
  const _component_expire_ps = _resolveComponent("expire-ps")!
  const _component_share_button = _resolveComponent("share-button")!
  const _component_layout = _resolveComponent("layout")!
  const _component_toast = _resolveComponent("toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_layout, {
        skin: _ctx.query.skin
      }, {
        header: _withCtx(() => [
          (!_ctx.openWait)
            ? (_openBlock(), _createBlock(_component_redpack_info, {
                key: 0,
                chainId: _ctx.query.chainIdInit,
                redPackId: _ctx.query.redPackId
              }, null, 8, ["chainId", "redPackId"]))
            : _createCommentVNode("", true),
          _createVNode(_Transition, { name: "opacity" }, {
            default: _withCtx(() => [
              (_ctx.openWait)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "open-wallet-container",
                    style: _normalizeStyle({
            backgroundImage: `linear-gradient(180deg, ${_ctx.bg} 0%, rgba(255,255,255,0.00) 100%)`
          })
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("h2", null, _toDisplayString(_ctx.$checkI18n(`download.${_ctx.openFailTips ? 'openFail': 'opening'}`)), 1),
                        _createElementVNode("p", null, _toDisplayString(_ctx.$checkI18n('download.ps')), 1),
                        (_ctx.openFailTips)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_personality_button, {
                                class: "download-btn",
                                type: "form",
                                onClick: _ctx.routeToDownloadLink
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("h3", null, _toDisplayString(_ctx.$checkI18n('download.downloadBtn')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createElementVNode("p", {
                                class: "retry",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.routeToFxRedpack && _ctx.routeToFxRedpack(...args)))
                              }, _toDisplayString(_ctx.$checkI18n('download.retryBtn')), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 4))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        footer: _withCtx(() => [
          (!_ctx.openWait)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_personality_button, {
                  type: "dark",
                  onClick: _ctx.routeToDownload
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.$checkI18n("receive.download")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_expire_ps),
                _createVNode(_component_share_button, {
                  class: "out-copy-btn text-shadow",
                  ref: "shareButtonRef",
                  onClick: _ctx.copyHandler
                }, null, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["skin"])
    ]),
    _createVNode(_component_toast, {
      msg: _ctx.toast.msg,
      "onUpdate:msg": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.toast.msg) = $event))
    }, null, 8, ["msg"])
  ], 64))
}